module.exports = __webpack_public_path__ + "img/un.5baf72b0.svg";